const bonding = {
  hero: {
    badge: "Естетична Дентална Медицина",
    title: "Дентален Бондинг",
    description:
      "Преобразете усмивката си с нашите експертни услуги за дентален бондинг. Използваме най-съвременни техники и композитна смола в цвета на зъбите, за да възстановим повредени, обезцветени или деформирани зъби, осигурявайки естествен резултат, който подобрява вашата усмивка и увереност.",
    ctas: {
      primary: "Запишете Консултация",
      secondary: "Научете за Процеса",
    },
    stats: {
      value1: "97%",
      value2: "4.9",
      title: "97% Удовлетвореност на Пациентите",
      subtitle: "Базирано на отзиви от пациенти",
    },
    imageAlt: "Процедура за дентален бондинг",
  },
  benefits: {
    heading: "Предимства на Денталния Бондинг",
    intro: "Открийте защо пациентите избират дентален бондинг за трансформация на усмивката си",
    items: [
      {
        title: "Процедура в Един Ден",
        description:
          "Завършете денталния бондинг само с едно посещение, спестявайки време без компромис с качеството.",
      },
      {
        title: "Минимално Инвазивен",
        description:
          "Запазете повече от естествената структура на зъба с този консервативен козметичен метод на лечение.",
      },
      {
        title: "Подобрен Външен Вид",
        description:
          "Подобрете усмивката си чрез възстановяване на счупени зъби, запълване на празнини и постигане на естествен цвят на зъбите.",
      },
      {
        title: "Естествен Резултат",
        description:
          "Нашето експертно съчетаване на композита с цвета на зъбите ви осигурява незабележими възстановявания.",
      },
      {
        title: "Моментална Увереност",
        description:
          "Тръгнете си с незабавно подобрена усмивка, която повишава самочувствието и увереността ви.",
      },
      {
        title: "Универсално Решение",
        description:
          "Решете множество козметични проблеми с едно универсално лечение, което може да бъде персонализирано според вашите нужди.",
      },
    ],
    bottomLinePrefix: "Искате да разберете дали денталният бондинг е подходящ за вас?",
    bottomLineCta: "Запишете консултация днес",
  },
  process: {
    heading: "Процесът на Бондинг",
    intro: "Нашият детайлен подход осигурява красиви, естествено изглеждащи резултати",
    steps: [
      {
        number: "01",
        title: "Консултация и Оценка",
        description:
          "Нашият зъболекар ще прегледа зъбите ви, ще обсъди вашите цели и ще определи дали денталният бондинг е подходящ за вас.",
      },
      {
        number: "02",
        title: "Планиране на Лечението",
        description:
          "Ще подберем идеалния нюанс на композита, който да съответства на естествените ви зъби и ще планираме процедурата за оптимални резултати.",
      },
      {
        number: "03",
        title: "Подготовка на Зъба",
        description:
          "Повърхността на зъба се награпавява внимателно и се нанася подготвителна течност, която помага за прилепването на бондинг материала.",
      },
      {
        number: "04",
        title: "Нанасяне на Бондинга",
        description:
          "Композитът в цвета на зъба се нанася, оформя се до желаната форма и се втвърдява със специална светлина.",
      },
      {
        number: "05",
        title: "Финални Щрихи",
        description:
          "Бондинг материалът се изпилява, оформя и полира, за да съответства на естествените ви зъби и да осигури комфортно захапване.",
      },
    ],
    expected: {
      heading: "Очаквани Резултати",
      left: [
        "Естествено изглеждащо възстановяване на счупени, напукани или обезцветени зъби",
        "Затваряне на малки разстояния между зъбите",
        "Подобрен външен вид на деформирани зъби",
      ],
      right: [
        "Защита на оголени зъбни корени поради отдръпнати венци",
        "Незабавни резултати само с едно посещение",
        "Подобрен външен вид на усмивката и повишена увереност",
      ],
    },
  },
  faq: {
    heading: "Често Задавани Въпроси",
    intro: "Всичко, което трябва да знаете за денталния бондинг",
    items: [
      {
        question: "Колко дълго издържа денталният бондинг?",
        answer:
          "Денталният бондинг обикновено издържа между 3 и 10 години, в зависимост от местоположението на бондинга, вашите орални навици и как се грижите за зъбите си. Редовните дентални прегледи и добрата устна хигиена могат да помогнат за удължаване на живота на денталния бондинг.",
      },
      {
        question: "Болезнена ли е процедурата за дентален бондинг?",
        answer:
          "Не, денталният бондинг обикновено е безболезнена процедура. В повечето случаи дори не е необходима анестезия, освен ако бондингът не се използва за запълване на кариес, зъбът трябва да се пробие, за да се промени формата му, или счупването е близо до нерва.",
      },
      {
        question: "Колко струва денталният бондинг?",
        answer:
          "Цената на денталния бондинг варира в зависимост от обхвата на процедурата, броя на третираните зъби и вашето местоположение. Като цяло, това е една от най-достъпните козметични дентални процедури. Предоставяме подробна оценка на разходите по време на консултацията.",
      },
      {
        question: "Колко време отнема процедурата за бондинг?",
        answer:
          "Денталният бондинг обикновено отнема между 30 и 60 минути на зъб. Целият процес често може да бъде завършен с едно посещение в кабинета, което го прави удобна опция за заетите пациенти.",
      },
      {
        question: "Как да се грижа за зъбите с бондинг?",
        answer:
          "Грижете се за зъбите с бондинг, както за естествените си зъби с редовно миене и почистване с конец. Избягвайте да хапете твърди предмети като лед, химикалки или нокти и ограничете консумацията на оцветяващи вещества като кафе, чай и тютюн. Редовните дентални прегледи са от съществено значение за поддържането на зъбите с бондинг.",
      },
      {
        question: "Може ли денталният бондинг да реши всички видове дентални проблеми?",
        answer:
          "Денталният бондинг е универсален, но не е подходящ за всички дентални проблеми. Работи добре за малки козметични подобрения, малки счупвания, празнини и обезцветяване. За по-обширни повреди или за зъби, които изпитват силен натиск при дъвчене, други лечения като фасети или корони могат да бъдат по-подходящи.",
      },
      {
        question: "Обратим ли е денталният бондинг?",
        answer:
          "Да, денталният бондинг обикновено е обратим, тъй като не изисква премахване на много, ако изобщо има такова, от оригиналния зъбен емайл. Ако решите да опитате различно козметично лечение в бъдеще, бондинг материалът може да бъде премахнат без трайни повреди на естествения ви зъб.",
      },
    ],
    bottomLine: "Имате още въпроси за денталния бондинг?",
    cta: "Свържете се с Нас",
  },
};

export default bonding;

